import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { map } from 'ramda';

/**
 *  todo: refactor component to not be hard coded for golfer count
 *  todo: make dynamic and to be given an array of qty values
 */
class QuantitySelector extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    onSelect: PropTypes.func,
    qty: PropTypes.number
  };

  render() {
    const { classes, qty, onSelect, qtyList } = this.props;
    const classOverides = {
      contained: classes.buttonContained,
      root: classes.buttonRoot,
      disabled: classes.disabled
    }

    const Buttons = map(
      _qty =>
        <Button
          key={_qty}
          onClick={() => onSelect(_qty)}
          variant={qty === _qty ? 'contained' : 'flat'}
          classes={classOverides} disabled={qty === _qty}
          className={`${classes.button} ${qty === _qty ? classes.selected : ''}`}
        >
         {_qty}
        </Button>,
        qtyList
    )

    return (
      <div style={{ display: 'flex' }}>
            {Buttons}
      </div>
    );
  }
}

const styles = theme => ({
  buttonContained: {
    '&$disabled': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  },
  buttonRoot: {
    '&:hover': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main
    }
  },
  button: {
    minWidth: 'auto',
    margin: theme.spacing.unit,
    color: theme.grouponBlack
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light
  },
  disabled: {}
});

export default withStyles(styles)(QuantitySelector);



// WEBPACK FOOTER //
// ./src/components/QuantitySelector/index.js